import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { line, lineRadial } from 'd3-shape';
import { isPolar } from '../../utils/coordinate';
import { select } from '../../utils/selection';
import { applyStyle, computeGradient, getTransform } from '../utils';
import { createElement } from '../../utils/createElement';
import { subObject } from '../../utils/helper';
import { angleWithQuadrant, dist, sub } from '../../utils/vector';
var DoublePath = createElement(function (g) {
  var _g$attributes = g.attributes,
    d1 = _g$attributes.d1,
    d2 = _g$attributes.d2,
    style1 = _g$attributes.style1,
    style2 = _g$attributes.style2;
  var document = g.ownerDocument;
  select(g).maybeAppend('line', function () {
    return document.createElement('path', {});
  }).style('d', d1).call(applyStyle, style1);
  select(g).maybeAppend('line1', function () {
    return document.createElement('path', {});
  }).style('d', d2).call(applyStyle, style2);
});
/**
 * Given a points sequence, split it into an array of defined points
 * and an array of undefined segments.
 *
 * Input - [[1, 2], [3, 4], [null, null], [null, null], [5, 6], [null, null], [7, 8]]
 * Output
 *  - [[1, 2], [3, 4], [5, 6], [7, 8]]
 *  - [
 *      [[3, 4], [5, 6]],
 *      [[5, 6], [7, 8]]
 *    ]
 */
function segmentation(points, defined) {
  var definedPoints = [];
  var segments = [];
  var m = false; // Is in a undefined sequence.
  var dp = null; // The previous defined point.
  var _iterator = _createForOfIteratorHelper(points),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var p = _step.value;
      // If current point is a undefined point,
      // enter a undefined sequence.
      if (!defined(p[0]) || !defined(p[1])) m = true;else {
        definedPoints.push(p);
        // If current point is a defined point,
        // and is in a undefined sequence, save
        // the two closest defined points as this
        // undefined sequence and exit it.
        if (m) {
          m = false;
          segments.push([dp, p]);
        }
        // Update the previous defined point.
        dp = p;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return [definedPoints, segments];
}
export var Curve = function Curve(options, context) {
  var curve = options.curve,
    _options$gradient = options.gradient,
    gradient = _options$gradient === void 0 ? false : _options$gradient,
    _options$gradientColo = options.gradientColor,
    gradientColor = _options$gradientColo === void 0 ? 'between' : _options$gradientColo,
    _options$defined = options.defined,
    defined = _options$defined === void 0 ? function (d) {
      return !Number.isNaN(d) && d !== undefined && d !== null;
    } : _options$defined,
    _options$connect = options.connect,
    connectNulls = _options$connect === void 0 ? false : _options$connect,
    style = __rest(options, ["curve", "gradient", "gradientColor", "defined", "connect"]);
  var coordinate = context.coordinate,
    document = context.document;
  return function (P, value, defaults) {
    // Compute styles.
    var defaultColor = defaults.color,
      defaultSize = defaults.lineWidth,
      rest = __rest(defaults, ["color", "lineWidth"]);
    var _value$color = value.color,
      color = _value$color === void 0 ? defaultColor : _value$color,
      _value$size = value.size,
      size = _value$size === void 0 ? defaultSize : _value$size,
      sc = value.seriesColor,
      sx = value.seriesX,
      sy = value.seriesY;
    var stroke = gradient && sc ? computeGradient(sc, sx, sy, gradient, gradientColor) : color;
    var transform = getTransform(coordinate, value);
    var finalStyle = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, rest), stroke && {
      stroke: stroke
    }), size && {
      lineWidth: size
    }), transform && {
      transform: transform
    }), style);
    // Compute points and segments.
    var linePath;
    if (isPolar(coordinate)) {
      var center = coordinate.getCenter();
      linePath = function linePath(points) {
        return lineRadial().angle(function (_, idx) {
          return angleWithQuadrant(sub(points[idx], center));
        }).radius(function (_, idx) {
          return dist(points[idx], center);
        }).defined(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            x = _ref2[0],
            y = _ref2[1];
          return defined(x) && defined(y);
        }).curve(curve)(points);
      };
    } else {
      linePath = line().x(function (d) {
        return d[0];
      }).y(function (d) {
        return d[1];
      }).defined(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          x = _ref4[0],
          y = _ref4[1];
        return defined(x) && defined(y);
      }).curve(curve);
    }
    var _segmentation = segmentation(P, defined),
      _segmentation2 = _slicedToArray(_segmentation, 2),
      DP = _segmentation2[0],
      MS = _segmentation2[1];
    var connectStyle = subObject(finalStyle, 'connect');
    var missing = !!MS.length;
    // Draw one path of connected defined points.
    if (!missing || connectNulls && !Object.keys(connectStyle).length) {
      return select(document.createElement('path', {})).style('d', linePath(DP) || []).call(applyStyle, finalStyle).node();
    }
    // Draw one path of unconnected defined points.
    if (missing && !connectNulls) {
      return select(document.createElement('path', {})).style('d', linePath(P)).call(applyStyle, finalStyle).node();
    }
    // Draw two path.
    // One for unconnected defined points.
    // One for connected segments.
    var connectPath = function connectPath(segments) {
      return segments.map(linePath).join(',');
    };
    return select(new DoublePath()).style('style1', Object.assign(Object.assign({}, finalStyle), connectStyle)).style('style2', finalStyle).style('d1', connectPath(MS)).style('d2', linePath(P)).node();
  };
};
Curve.props = {
  defaultMarker: 'smooth',
  defaultEnterAnimation: 'fadeIn',
  defaultUpdateAnimation: 'morphing',
  defaultExitAnimation: 'fadeOut'
};